import {
  Text,
  Box,
  Columns,
  Column,
  Stack,
  IconArrow,
  ButtonLink,
} from 'braid-design-system';

import CustomSvg from 'src/components/CustomSvg/CustomSvg';
import { getConfigValues } from 'src/config';
import Routes from 'src/config/routes';
import CalculatorSvg from 'src/images/calculator.svg';
import ScreeningSvg from 'src/images/screening.svg';
import WriteSvg from 'src/images/write.svg';

import { CustomHeading } from './CustomHeading';

export const ExclusiveResources = () => {
  const contents = [
    {
      title: 'Guide to selling a business',
      image: WriteSvg,
    },
    {
      title: 'Business value calculator',
      image: CalculatorSvg,
    },
    {
      title: 'Buyer screening guide',
      image: ScreeningSvg,
    },
  ];

  return (
    <Stack space="large">
      <Stack space="medium">
        <Box textAlign="center">
          <CustomHeading semanticLevel="h2" mobileLevel="1" tabletLevel="2">
            Not ready to sell yet?
          </CustomHeading>
        </Box>

        <Text tone="secondary" align="center">
          Sign up with SEEK Business to access exclusive seller resources, so
          when you want to sell, you&apos;re ready to sell.
        </Text>
      </Stack>

      <Columns space="xlarge" collapseBelow="tablet">
        {contents.map((c, index) => (
          <Column key={index}>
            <Box
              display="flex"
              height="full"
              justifyContent="spaceBetween"
              flexDirection="column"
              alignItems="center"
            >
              <Stack space="xsmall" align="center">
                <CustomSvg svg={c.image} />
                <Box marginTop="small">
                  <CustomHeading
                    semanticLevel="h3"
                    mobileLevel="2"
                    tabletLevel="3"
                  >
                    {c.title}
                  </CustomHeading>
                </Box>
              </Stack>

              <Box maxWidth="xsmall" marginTop="gutter">
                <ButtonLink
                  id="learn-more-button"
                  tone="brandAccent"
                  variant="soft"
                  href={`${getConfigValues().HEADER_SERVER_BASE}${
                    Routes.SIGN_IN_URL
                  }?returnUrl=${Routes.DASHBOARD}`}
                >
                  Learn More&nbsp;&nbsp;
                  <IconArrow direction="right" />
                </ButtonLink>
              </Box>
            </Box>
          </Column>
        ))}
      </Columns>
    </Stack>
  );
};
